/**
 * Represents the possible statuses of a submission period.
 */
export enum SubmissionPeriodStatusModel {
	/**
	 * Indicates a new submission period that has not yet been processed.
	 */
	New = 1,
	/**
	 * Indicates an active submission period that is currently being worked on.
	 */
	Active = 2,
	/**
	 * Indicates a submission period that is under quality check before final submission.
	 */
	QualityCheck = 3,
	/**
	 * Indicates a submission period that has already been submitted.
	 */
	Submitted = 4
}
